export default {"src":"/_next/static/media/left.2c17ebbe.svg","height":675,"width":551,"blurWidth":0,"blurHeight":0};